import { Col, Input, Row, Switch } from "antd";
import { I18N_NS } from "Config/i18n";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { EmailSelect } from "../EmailSendModal/EmailSelect";

interface EmailSenderSelectProps {
  onChange?: (val: string) => void;
  value?: string;
}

export const EmailSenderSelect = ({ onChange }: EmailSenderSelectProps) => {
  const [isExternalSender, setIsExternalSender] = React.useState(false);
  const { t } = useTranslation(I18N_NS.PROJECT);

  const toggleSender = () => {
    setIsExternalSender(!isExternalSender);
    onChange(undefined);
  };

  return (
    <Row gutter={10}>
      <Col style={{ flexGrow: 1, height: 40 }}>
        {isExternalSender ? (
          <Input placeholder={t("Sender")} onChange={(e) => onChange(e.target.value)} type="email" />
        ) : (
          <EmailSelect showSearch={true} isGroupHidden={true} placeholder={t("Sender")} onChange={onChange} />
        )}
      </Col>
      <Col style={{ display: "flex", alignItems: "center" }}>
        <Switch onChange={toggleSender} checked={isExternalSender} /> {t("External email")}
      </Col>
    </Row>
  );
};
